export var AssetType;
(function (AssetType) {
    AssetType[AssetType["HOMEPAGE_IMAGE"] = 1] = "HOMEPAGE_IMAGE";
})(AssetType || (AssetType = {}));
